import { useContext } from 'react';
import { signOut } from 'firebase/auth';
import { Context } from '@components/Context';
import { useAccountStore } from '@components/dashboard/context/UserDashboardContext';
import { NavContext } from '@components/navigation/Context';
import { NavStatus } from '@contracts';
import useNavigate from '@utils/useNavigate';

const DEFAULT_OPTIONS: LogoutOptions = {
  navigateLink: '/dashboard/login'
};

interface LogoutOptions {
  navigateLink?: string;
}

export default function useLogoutHandle(options: LogoutOptions = DEFAULT_OPTIONS) {
  const { state, dispatch } = useContext(Context);
  const { navDispatch } = useContext(NavContext);
  const { navigateWrapper } = useNavigate();
  const resetState = useAccountStore((accountState) => accountState.reset);

  const handleCloseNav = () => {
    navDispatch({ type: 'setStatus', data: NavStatus.Default });
    navDispatch({ type: 'removeNavbarSelectedCategories' });
  };

  return () => {
    if (!state.firebaseAuth) return;

    signOut(state.firebaseAuth)
      .then(() => {
        handleCloseNav();
        resetState();
        dispatch({ type: 'cartClear' });

        if (options.navigateLink) {
          navigateWrapper(options.navigateLink);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
